import React, { useEffect, useState } from 'react'
import { MaterialReactTable, createMRTColumnHelper, useMaterialReactTable, } from 'material-react-table';
import Breadcrumb from '../../../../Components/Breadcrumb/Breadcrumb'
import EnvVar from '../../../../EnvVar'
import axios from 'axios'
import Cookies from 'js-cookie'
import { Box, Button } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { mkConfig, generateCsv, download } from 'export-to-csv';

function AmbassadorData() {
    const baseURL = EnvVar()
    const token = Cookies.get('jwt')
    const [stats, setStats] = useState({})
    const [data, setData] = useState([])
    useEffect(() => {
        // Getting Stats Data
        const statsData = () => {
            const config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${baseURL}/user/adminstats`,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token,
                },
                withCredentials: true
            };

            axios.request(config)
                .then((response) => {
                    const statsValue = response.data.ambassador;
                    setStats(statsValue)
                    // console.log("Getting stats value", statsValue);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
        statsData()

        // Getting Leaderboard Data
        const leaderboardData = () => {
            const config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${baseURL}/user/ambassadorinfo`,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token,
                },
                withCredentials: true
            };

            axios.request(config)
                .then((response) => {
                    let leaderboard = response.data.ambassador;
                    leaderboard = leaderboard.map(
                        item => {
                            const { points, ...rest } = item; // Destructure to remove points
                            return {
                                ...rest,
                                point: points.length > 0 ? points[0].totalpoint : 0
                            };
                        }
                    )

                    // console.log('new data not row ', leaderboard)
                    setData(leaderboard)
                    // console.log("Getting Leaderboard data", leaderboard);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
        leaderboardData()
    }, []);
    const columnHelper = createMRTColumnHelper();

    const columns = [
        columnHelper.accessor('fullname', {
            header: 'Ambassador Name',
        }),
        columnHelper.accessor('totalsurveyd', {
            header: 'Individual Trained',
        }),
        columnHelper.accessor('totalevent', {
            header: 'FTL Event Conducted',
        }),
        columnHelper.accessor('totalTestimonials', {
            header: 'Testimonials',
        }),
        columnHelper.accessor('totalStories', {
            header: 'Total Stories',
        }),
        columnHelper.accessor('totalCreativePosts', {
            header: 'Creative Post',
        }),
        columnHelper.accessor('point', {
            header: 'Score',
        }),
    ]

    const csvConfig = mkConfig({
        fieldSeparator: ',',
        decimalSeparator: '.',
        useKeysAsHeaders: true,
    });

    const handleExportRows = (rows) => {
        let rowData = rows.map((row) => row.original);
        console.log('rowDAtea ', rowData)
        const csv = generateCsv(csvConfig)(rowData);
        download(csvConfig)(csv);
    };

    const handleExportData = () => {
        console.log('data is ', data)
        const csv = generateCsv(csvConfig)(data);
        download(csvConfig)(csv);
    };


    const table = useMaterialReactTable({
        columns,
        data, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
        enableRowSelection: true,
        columnFilterDisplayMode: 'popover',
        paginationDisplayMode: 'pages',
        positionToolbarAlertBanner: 'bottom',
        renderTopToolbarCustomActions: ({ table }) => (
            <Box
                sx={{
                    display: 'flex',
                    gap: '16px',
                    padding: '8px',
                    flexWrap: 'wrap',
                }}
            >
                <Button
                    //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                    onClick={handleExportData}
                    startIcon={<FileDownloadIcon />}
                >
                    Export All Data
                </Button>
                <Button
                    disabled={table.getPrePaginationRowModel().rows.length === 0}
                    //export all rows, including from the next page, (still respects filtering and sorting)
                    onClick={() =>
                        handleExportRows(table.getPrePaginationRowModel().rows)
                    }
                    startIcon={<FileDownloadIcon />}
                >
                    Export All Rows
                </Button>


                <Button
                    disabled={table.getRowModel().rows.length === 0}
                    //export all rows as seen on the screen (respects pagination, sorting, filtering, etc.)
                    onClick={() => handleExportRows(table.getRowModel().rows)}
                    startIcon={<FileDownloadIcon />}
                >
                    Export Page Rows
                </Button>
                <Button
                    disabled={
                        !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
                    }
                    //only export selected rows
                    onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
                    startIcon={<FileDownloadIcon />}
                >
                    Export Selected Rows
                </Button>
            </Box>
        ),
    });

    return (
        <>
            <Breadcrumb data="FTL Ambassador Data" />
            <div className='content-body'>
                <div className="table-data">
                    <div className='row justify-content-between mb-4'>
                        <div className='col-lg-3'>
                            <div className='total-participants'>Total Number of Participants</div>
                        </div>
                        <div className='col-lg-8'>
                            <div className='region-wise'>
                                <div className='region-heading'>Region Wise</div>
                                <div className='sides-options'>
                                    <div className='row'>
                                        <div className='col-lg-2'><span>North : {stats.north ?? 0}</span></div>
                                        <div className='col-lg-2'><span>South: {stats.south ?? 0}</span></div>
                                        <div className='col-lg-2'><span>East: {stats.east ?? 0}</span></div>
                                        <div className='col-lg-2'><span>West: {stats.west ?? 0}</span></div>
                                        <div className='col-lg-2'><span>Centre: {stats.center ?? 0}</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <MaterialReactTable table={table} />
                </div>
            </div>
        </>
    )
}

export default AmbassadorData
